import config from "config/config";
import { apiRequest } from "./apiInterceptor";

export class FilesAPI {
  static async getFilesSummary() {
    const result = await apiRequest
      .get(config.api.files.summary())
      .send();
    return result.body;
  }

  static async fetchDocuments(customerId: string, isInternal: boolean) {
    if (!isInternal) {
      return { body: [] };
    }
    return await apiRequest
      .get(config.api.files.get(customerId))
      .send();
  }

   static async updateFileWithName(
    name: string,
    fileId: string,
    customerId: string,
  ) {
    const response = await apiRequest
      .put(config.api.file.updateFileName(customerId, fileId))
      .send({
        newName: name,
      });

    return response;
  }
}
